import SideLogo from 'assets/Icons/Logo/SideLogo';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { zIndex } from 'styles/Global/globalStyles';
import HospitalSideBar from '../Hospital/HospitalSideBar';
import { getVisibleSideBarConstants } from 'constants/SideBarConstants';
import { BackgroundColor, BorderColor, PrimaryColor } from 'styles/Global/colorSemantic';
import { GnbButton } from 'styles/Global/buttonStyles';
import { Radius } from 'styles/Global/objectStyles';
import { useLoginStore } from 'store/useLoginDataStore';
import AdminSideBar from 'components/Admin/AdminSideBar';
import ExCounsSideBar from 'components/Hospital/ExCounsSideBar';
import CLAdminSideBar from 'components/CLAdmin/CLAdminSideBar';
import { pagePaths } from 'constants/path';
import SettingsSideBar from 'components/Settings/SettingsSideBar';

const GNB_INDEX = {
    DOCTORS_COUNSELING: 0,
    CALORIE_LAB: 1,
    SETTINGS: 2,
} as const;

type GnbService = keyof typeof GNB_INDEX;

const SideBar = ({ location }: { location: boolean }) => {
    const { loginData } = useLoginStore();
    const { pathname } = useLocation();

    const [selectedSideBar, setSelectedSideBar] = useState<number>(0);

    const { state } = useLocation();

    // TODO. refactoring 필요
    useEffect(() => {
        if (pathname.includes('/admin/settings')) {
            setSelectedSideBar(GNB_INDEX.SETTINGS);
        } else if (pathname.includes('/admin/cl')) {
            setSelectedSideBar(GNB_INDEX.CALORIE_LAB);
        } else if (pathname.includes('counseling')) {
            if (state?.from?.includes('/admin/cl')) {
                setSelectedSideBar(GNB_INDEX.CALORIE_LAB);
            } else {
                setSelectedSideBar(GNB_INDEX.DOCTORS_COUNSELING);
            }
        } else {
            setSelectedSideBar(GNB_INDEX.DOCTORS_COUNSELING);
        }
    }, [pathname, state]);

    const handleDoctorsCounselingPath = () => {
        if (loginData.level === 100) {
            return pagePaths.adminDiagnosisList;
        }

        if (loginData.level === 10 || loginData.level === 20) {
            return pagePaths.mindUpAdminTodayDiagnosis;
        }

        return pagePaths.dckHome;
    };

    const handleGnbNav = (service: GnbService) => {
        switch (service) {
            case 'DOCTORS_COUNSELING':
                return handleDoctorsCounselingPath();
            case 'CALORIE_LAB':
                return pagePaths.CLAdminManagePatient;
            case 'SETTINGS':
                return pagePaths.SettingsAdminUserRole;
            default:
                return '';
        }
    };

    const handleRanderSideBar = () => {
        if (selectedSideBar === GNB_INDEX.DOCTORS_COUNSELING) {
            return loginData.level !== 100 ? loginData.level === 10 || loginData.level === 20 ? <ExCounsSideBar /> : <HospitalSideBar /> : <AdminSideBar />;
        } else if (selectedSideBar === GNB_INDEX.CALORIE_LAB) {
            return <CLAdminSideBar />;
        } else if (selectedSideBar === GNB_INDEX.SETTINGS) {
            return <SettingsSideBar />;
        }
        return null;
    };

    const visibleSideBarConstants = getVisibleSideBarConstants(loginData.hospitalServices, loginData.level);

    return (
        <Layout>
            <Container>
                <SideLogo />
                {location && (
                    <>
                        {visibleSideBarConstants.map((list) => {
                            const gnbIndex = GNB_INDEX[list.service as GnbService];

                            return (
                                <GnbButton key={list.service} to={handleGnbNav(list.service as GnbService)} $idx={gnbIndex} selected={selectedSideBar}>
                                    {list.icon}
                                    {list.name}
                                </GnbButton>
                            );
                        })}
                    </>
                )}
            </Container>
            {location && <SideListLayout>{handleRanderSideBar()}</SideListLayout>}
        </Layout>
    );
};

export default SideBar;

const Layout = styled.div`
    display: flex;
    min-height: 100vh;
    position: fixed;
    top: 0;
    z-index: ${zIndex.sideBar};
    background-color: ${PrimaryColor.color_primary_heavy};
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 88px;
    padding-top: 25px;
    background-color: ${PrimaryColor.color_primary_heavy};
`;

const SideListLayout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 232px;
    padding: 20px 16px;
    border-radius: ${Radius.radius_24} 0px 0px ${Radius.radius_24};
    background-color: ${BackgroundColor.color_background_primary_neutral};
    border-right: 1px solid ${BorderColor.color_border_light};
`;
